import environment from "./environment";
import { debounce } from "lodash";
/**
 * 图片适配资源文件
 * @param obj 数据对象
 * @param prop 属性
 * @returns
 */
export const fileUrl = (obj, prop) => {
  if (!obj[prop]) {
    return;
  }
  return `${environment.baseURL + obj[prop]}`;
};

export const isExternal = (url = "") => {
  return /^(https?:|mailto:|tel:)/.test(url);
};

/**
 * 滚动锚点
 */
export const scrollAnchor = function () {
  let scrollH = document.documentElement.scrollTop || document.body.scrollTop;

  const getScrollTop = () => {
    let scrollTop = 0,
      bodyScrollTop = 0,
      documentScrollTop = 0;
    if (document.body) {
      bodyScrollTop = document.body.scrollTop;
    }
    if (document.documentElement) {
      documentScrollTop = document.documentElement.scrollTop;
    }
    scrollTop =
      bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
    return scrollTop;
  };

  const getWindowHeight = () => {
    let windowHeight = 0;
    if (document.compatMode == "CSS1Compat") {
      windowHeight = document.documentElement.clientHeight;
    } else {
      windowHeight = document.body.clientHeight;
    }
    return windowHeight;
  };

  const getScrollHeight = () => {
    let scrollHeight = 0,
      bodyScrollHeight = 0,
      documentScrollHeight = 0;
    if (document.body) {
      bodyScrollHeight = document.body.scrollHeight;
    }
    if (document.documentElement) {
      documentScrollHeight = document.documentElement.scrollHeight;
    }
    scrollHeight =
      bodyScrollHeight - documentScrollHeight > 0
        ? bodyScrollHeight
        : documentScrollHeight;
    return scrollHeight;
  };

  const updateNav = (secItems, navItems) => {
    if (getScrollTop() === 0) {
      navOn(0, navItems);
    }
    if (getScrollTop() + getWindowHeight() === getScrollHeight()) {
      navOn(secItems.length - 1, navItems);
    } else {
      secItems.forEach((item, index) => {
        if (getScrollTop() >= item.offsetTop) {
          navOn(index, navItems);
        }
      });
    }
  };

  const scrollFun = (secItems, navItems) => {
    if (!secItems && !navItems) {
      return;
    }
    return debounce(() => updateNav(secItems, navItems), 100);
  };

  const toScroll = (index, secItems) => {
    const scrollY = secItems[index].offsetTop;
    window.scrollTo(0, scrollY);
  };

  const navOn = (index, navItems) => {
    navItems.forEach((item) => {
      item.classList = "";
    });
    navItems[index].classList = "active";
  };

  return {
    init: ({ sideClass, navClass, secClass }) => {
      let navItems = document.querySelectorAll(navClass);
      let secItems = document.querySelectorAll(secClass);
      let sideMaodian = document.querySelector(sideClass);
      if (scrollH === 0) {
        navOn(0, navItems);
      }

      sideMaodian.onclick = function (e) {
        let item = e.target.parentNode;
        let lists = Array.from(sideMaodian.querySelectorAll("li"));
        let index = lists.indexOf(item); //li 索引
        if (item.tagName.toLowerCase() === "li") {
          navOn(index, navItems);
          toScroll(index, secItems);
        }
      };

      window.addEventListener("scroll", scrollFun(secItems, navItems));
    },
    destroy: () => {
      window.removeEventListener("scroll", scrollFun());
    },
  };
};

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}
